import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import type { DigitalAsset } from "../types";

interface FacebookSectionProps {
  asset: DigitalAsset;
  canViewFacebook: boolean;
  canViewDirectoryGeneralDescription: boolean;
}

const FacebookSection = ({
  asset,
  canViewFacebook,
  canViewDirectoryGeneralDescription,
}: FacebookSectionProps) => (
  <Disclosure defaultOpen>
    {({ open }) => (
      <div className="bg-white rounded-lg box-shadow">
        <Disclosure.Button className="disclosureBtn ml-2">
          <ChevronRight
            className={`${
              open ? "transform rotate-90" : " text-gray-500"
            } text-gray-500 w-5 h-5 `}
          />
          <span className="disclosureLabel ml-2">Facebook</span>
        </Disclosure.Button>

        <Disclosure.Panel className="text-xs">
          <div className="grid grid-cols-2 text-xs">
            {canViewFacebook && (
              <div className="grid grid-cols-1 py-2 px-4 space-y-2">
                <label className="mx-4 expandedLabel fontExpand">
                  Facebook Username - Page URL:
                </label>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mx-4 expandedData fontExpand text-blue-500 underline break-all self-center"
                  href={
                    asset.facebook_Username_Page_Url__C &&
                    asset.facebook_Username_Page_Url__C !== "NULL"
                      ? asset.facebook_Username_Page_Url__C
                      : ""
                  }
                >
                  {asset.facebook_Username_Page_Url__C !== "NULL"
                    ? asset.facebook_Username_Page_Url__C
                    : ""}
                </a>
                <div className="border-b border-gray-200"></div>
              </div>
            )}

            {canViewDirectoryGeneralDescription && (
              <div className="grid grid-cols-1 py-2 px-4 space-y-2">
                <label className="mx-4 expandedLabel fontExpand">
                  Directory General Description:
                </label>
                <div className="mx-4 expandedData fontExpand">
                  {asset.directory_General_Description__C !== "NULL"
                    ? asset.directory_General_Description__C
                    : ""}
                </div>
                <div className="border-b border-gray-200"></div>
              </div>
            )}

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Directory Company Story:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.directory_Company_Story__C &&
                asset.directory_Company_Story__C !== "NULL"
                  ? asset.directory_Company_Story__C
                  : ""}
              </div>
            </div>

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Company Overview:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.facebook_Company_Overview__C &&
                asset.facebook_Company_Overview__C !== "NULL"
                  ? asset.facebook_Company_Overview__C
                  : ""}
              </div>
            </div>
          </div>
        </Disclosure.Panel>
      </div>
    )}
  </Disclosure>
);

export default FacebookSection;